import React from "react";

const Animation = () => {
  return (
    <div>
      <div className="animation-header purple-text text-center" id="animation">
        Welcome
      </div>
      <div className="gif-container">
        <gif className="gif-board" controls autoPlay="autoplay" muted>
          <source src="./video/example.gif" type="image/gif"/>    
        </gif>
        <gif className="gif-board" controls autoPlay="autoplay" muted>
          <source src="./video/Donkey video 2 FINAL.gif" type="image/gif"/>    
        </gif>
      </div>
      
    </div>
  );  
};

export default Animation;